(function($) {
  $( "select" ).change(function() {
    $(this).addClass('is-selected');
  });

})(jQuery);